// extracted by mini-css-extract-plugin
export default {"content":"List_content__EaqGM","tabs":"List_tabs__B2KL-","tabItem":"List_tabItem__+qjLK","active":"List_active__E5zsp","con":"List_con__lGpIF","emp":"List_emp__P-VOW"};